export default {
  /**
   * ログイン情報
   */
  state() {
    return {
      /**
       * コンテンツサービスID(173/190/062？)
       */
      contentsServiceId: null,
      /**
       * ログイン状態
       */
      loginState: false,
      /**
       * 初回ログイン完了
       */
      firstLoginCheckFlag: null
    };
  },
  /**
   * ログイン情報取得
   */
  getters: {
    /**
     * 全てのログイン情報を取得
     * @param {*} state ログイン情報
     * @returns 全てのログイン情報
     */
    getAllLoginInformation(state) {
      return state;
    },
    /**
    /**
     * コンテンツサービスID(173/190/062？)
     * @param {*} state ログイン情報
     * @returns ログイン中のコンテンツサービスID(173/190/062？)
     */
    getContentsServiceId(state) {
      return state.contentsServiceId;
    },
    /**
     * ログイン状態
     * @param {*} state ログイン情報
     * @returns ログイン中かどうか
     */
    getLoginState(state) {
      return state.loginState;
    },
    /**
     * 初回ログイン判定フラグ
     * @param {*} state ログイン情報
     * @returns 初めてログインしたかどうか
     */
    getFirstLoginCheckFlag(state) {
      return state.firstLoginCheckFlag;
    }
  },
  /**
   * ログイン情報設定
   */
  mutations: {
    /**
     * コンテンツサービスID(173/190/062？)
     * @param {*} state ログイン情報
     * @param {*} value 設定する値
     */
    setContentsServiceId(state, value) {
      state.contentsServiceId = value;
    },
    /**
     * ログイン状態
     * @param {*} state ログイン情報
     * @param {*} value 設定する値
     */
    setLoginState(state, value) {
      state.loginState = value;
    },
    /**
     * 初回ログイン判定フラグ(初回ログインの1回のみ使用)
     * @param {*} state ログイン情報
     * @param {*} value 設定する値
     */
    setFirstLoginCheckFlag(state, value) {
      state.firstLoginCheckFlag = value;
    },
    /**
     * 保存しているすべての値を削除する
     * @param {*} state
     */
    removeAll(state) {
      state.contentsServiceId = null;
      state.loginState = false;
      state.firstLoginCheckFlag = null;
    }
  }
};
